export default function(data, parent) {
  var self = this;
  self.$el = null;

  self.enrollment_fields_info = ko.observable({});

  // necessary for shared partial
  self.userPresent = function() {
    return true;
  };

  self.initCardUI = function(element, item) {
    //This fn needs to be called in an afterRender function of a loop or manually
    if (_.isEmpty(element)) {
      element = $('#course-' + item.id())[0];
    }
    self.$el = $(element);
    self.initTagInputs(element);

    if(self.student_access_on_draft_course()){
      self.showNotPublishedNotice()
    }

    self.student_access_on_draft_course(null);
  };

  self.initTagInputs = function(element) {
    var $el = $(element).find('.js-tagsinput');
    if (typeof $el.tagsinput != 'undefined') {
      $el.tagsinput({
        confirmKeys: [9, 13, 188],
        trimValue: true,
        allowDuplicates: false
      });
    }
  };

  self.showOptionsMenu = function(item, event) {
    var $card = $('#course-' + item.id());
    $card.find('.js-course-card-options-menu').show();
    event.stopPropagation();
  };

  self.hideOptionsMenu = function($card) {
    var $menu = $('.js-course-card-options-menu', $card);
    $menu.hide();
  };

  self.showShareModal = function(item, event) {
    var emailShareCb = function(item, emailList) {
      self.shareEmails(emailList);
      self.sendShareEmail(item, event);
    };
    var params = {modal_title: 'Share Course', shareableObj: {id: item.id(), title: item.name(), description: item.description(), share_url: item.course_share_url() }, emailShareCb: emailShareCb};
    var modal = new Kadenze.ShareModal(params);
    modal.show();
  };

  self.showShareMenu = function(item, event) {
    var $card = $('#course-' + item.id());
    var $shareMenu = $card.find('.js-course-card-share-menu');
    $shareMenu.show();
    $card.find('.js-course-share-list').show();
    $card.find('.course-card__share_btn')[0].focus();
    self.bindShareModalEvents($shareMenu, item, event);
    event.stopPropagation();
  };

  self.hideShareMenu = function(item, event) {
    var $card = $('#course-' + item.id);
    $card.find('.js-course-card-share-menu').hide();
    $card.find('.js-course-share-list').show();
    $card.find('.card__actions_icon').focus();
    event.stopPropagation();
  };

  self.bindShareModalEvents = function($shareMenu, item, event) {
    // hide sharemenu when focus leaves the modal
    if(!Kadenze.UIUtil.isSafari()) {
      var timeout;
      $shareMenu.find('a, input').on('focus.course_share_modal', function(){
        clearTimeout(timeout);
      });
      $shareMenu.find('a, input').on('blur.course_share_modal', function(){
        timeout = setTimeout(function () {
          self.hideEmailScreen(item, event);
          self.hideShareMenu(item, event);
        }, 5);
      });
    }
    // hide sharemenu when user presses esc key
    $(document).off('keyup.course_share_modal').on('keyup.course_share_modal', function(event) {
      if(event.which == 27){
        self.hideEmailScreen(item, event);
        self.hideShareMenu(item, event);
      }
    });
  };

  self.showEmailScreen = function(item, event) {
    var $card = $('#course-' + item.id());
    $card.find('.js-course-share-list').hide();
    $card.find('.js-course-card-email').show();
    $card.find('.bootstrap-tagsinput input')[0].focus();
    event.stopPropagation();
  };

  self.hideEmailScreen = function(item, event) {
    var $card = $('#course-' + item.id);
    $card.find('.js-course-card-share-menu').show();
    $card.find('.js-course-share-list').show();
    $card.find('.js-course-card-email').hide();
    if ($card.find('.js-tagsinput').length > 0 && typeof $card.find('.js-tagsinput').tagsinput != 'undefined') {
      $card.find('.js-tagsinput').tagsinput('removeAll');
    }
    self.shareEmails('');
    event.stopPropagation();
  };

  self.sendShareEmail = function(item, event) {
    //Manually trigger an enter key press just in case if the user didn't
    //This is needed for tags input to accept all emails
    var e = jQuery.Event('keydown', { which: $.ui.keyCode.ENTER });
    self.$el.find('.bootstrap-tagsinput > input').trigger(e);

    var client_errors = ko.validation.group([self.shareEmails], { deep: true });
    if (_.compact(client_errors()).length === 0) {
      self.shareCourse(item, event);
    } else {
      client_errors.showAllMessages();
      new Kadenze.Notice.error({message: client_errors()[0]});
    }
  };

  self.areEmailsValid = function(emails) {
    if (_.isEmpty(emails)) {
      return false;
    } else {
      return _.every(emails.split(','), function(email) {
        return (/^.+@.+\..+$/i).test(email);
      });
    }
  };

  //TODO: Remove this once we convert other functions to use Kadenze.UIUtil.confirmAction
  self.confirmAction = function($card, title, prompt, confirmed, cancelled) {
    var $holder = $card.find('.js-confirmation');
    var $prompt = $(
      JST['templates/card-confirmation']({
        title: title,
        body: prompt,
        cancel_btn_text: 'No',
        ok_btn_text: 'Yes'
      })
    );
    $holder.html($prompt);
    $prompt.find('.btn--del').on('click', function() {
      $prompt.hide();
      if(typeof cancelled == 'function') {
        cancelled();
      }
    });
    $prompt.find('.btn--prim').on('click', function() {
      $prompt.hide();
      if(typeof confirmed == 'function') {
        confirmed();
      }
    });
    $prompt.show();
  };

  self.showCourse = function(element) {
    if (element.nodeType === 1)
      $(element).hide().fadeIn();
  };

  self.hideCourse = function(element) {
    if (element.nodeType === 1)
      $(element).fadeOut();
  };

  self.draft = function() {
    return self.is_draft() || self.is_cloning();
  };

  self.upcoming = function() {
    return self.is_upcoming() || self.is_pending();
  };

  self.archived = function() {
    if (self.current_user) {
      return self.is_ended() || self.current_user.is_archived();
    }
    else {
      return self.is_ended();
    }
  };

  self.enrollment_fields_group = ko.computed(function() {
    if (!self.current_user || !_.isFunction(self.enrollment_fields))
      return {};
    return _.groupBy(self.enrollment_fields(), function(field) {
      return field.section();
    });
  });

  self.forCreditInfo = function(attrObs) {
    return ko.computed({
      read: function() {
        return self.enrollment_fields_info()[attrObs()] || null;
      },
      write: function(val) {
        self.enrollment_fields_info()[attrObs()] = val;
        self.enrollment_fields_info.valueHasMutated();
      }
    });
  };

  self.submitEnrollmentFields = function(vm, evt) {
    var loader = Ladda.create(evt.target);
    loader.start();

    var data = {user: {for_credit_info: ko.mapping.toJS(self.current_user.for_credit_info)} };
    data.user.for_credit_info = _.extend(data.user.for_credit_info, ko.mapping.toJS(self.enrollment_fields_info));

    var req = new Kadenze.AjaxRequest({
      type: 'PUT',
      url: Kadenze.Routes.users_path(),
      data: data
    });

    req.done(function(res) {
      self.unlockCourse(loader);
    });

    req.fail(function(xhr, status, msg) {
      if (xhr.responseJSON) {
        msg = xhr.responseJSON.errors;
      }
      new Kadenze.Notice.error({message: msg});
      loader.stop();
    });
  };

  self.unlockCourse = function(loader) {
    var req = new Kadenze.AjaxRequest({
      type: 'POST',
      url: Kadenze.Routes.unlock_course_path(self.id()),
      data: { type: 'credit' }
    });

    req.done(function(res) {
      if (res && res.redirect_path) {
        window.location.href = res.redirect_path;
      }
    });

    req.fail(function(xhr, status, msg) {
      if (xhr.responseJSON) {
        msg = xhr.responseJSON.errors;
      }
      new Kadenze.Notice.error({message: msg});
      if (loader) {
        loader.stop();
      }
    });
  };

  self.showEnrollmentFieldsEntry = function(vm, evt) {
    $('.js-course-unlock-modal--fields', self.$el).modal('show');
  };

  self.showLockedNotice = function(vm, evt) {
    $('.js-course-locked-modal--fields', self.$el).modal('show');
  };

  self.showCohortLockedNotice = function(vm, evt) {
    $('.js-course-cohort-locked-modal--fields', self.$el).modal('show');
  };

  self.showNotPublishedNotice = function(vm, evt) {
    $('.js-course-not-published-modal--fields', self.$el).modal('show');
  };

  this.getCourseAction = (course, isShareAction) => {
    let title = 'View';
    let handler = () => true

    //
    // document.location.origin doesn't exist in IE :(
    //
    if (!document.location.origin)
      document.location.origin = document.location.protocol + '//' +
                                   document.location.hostname +
                                     (document.location.port ?
                                       ':' + document.location.port :
                                       '');

    var path = course.course_info_path;

    if (course.current_user) {
      if (course.current_user.is_student()) {
        if (self.archived()) {
          title = Kadenze.I18n.t('dict.view');
          path = course.course_info_path;
        } else {
          title = Kadenze.I18n.t('dict.enter');

          if (self.upcoming()) {
            path = course.course_info_path;
          } else {
            path = course.course_path;
          }
        }

        if (course.is_cohort_locked()) {
          handler = self.showCohortLockedNotice;
        } else if (course.is_draft()) {
          handler = self.showNotPublishedNotice;
        }
      } else if (course.current_user.is_instructor() || course.current_user.is_admin()) {
        if (self.draft() || self.upcoming() || self.is_denied()) {
          title = Kadenze.I18n.t('dict.edit');
          path = course.course_path;
        } else if (self.archived()) {
          title = Kadenze.I18n.t('dict.view');
          path = course.course_path;
        } else {
          title = Kadenze.I18n.t('dict.teach');
          path = course.course_path;
        }
      } else if (course.current_user.is_locked()) {
        if (self.upcoming()) {
          title = Kadenze.I18n.t('dict.view');
          path = course.course_info_path;
        } else {
          title = Kadenze.I18n.t('dict.enter');
        }

        if (ko.unwrap(course.is_private) && ko.unwrap(course.for_credit)) {
          path = course.course_info_path;
        } else {
          if (course.prerequisite_courses().length > 0) {
            handler = self.showLockedNotice;
          } else {
            handler = self.showEnrollmentFieldsEntry;
          }
        }
      }
    }

    return { title, path, handler };
  };

  /*------------------------------------------------STATE MANAGEMENT--------------------------------------------------*/
  self.shareCourse = function(item, event) {
    // var url = Kadenze.Routes.share_course_path(item.id, {emails: self.shareEmails()});
    // var method = 'PATCH';

    // Kadenze.UIUtil.makeRequest(url, method, null, parent.$el, null, function (data, textStatus, xhr) {
    new Kadenze.Notice.success("This feature is not available for now.");
    // }, function (xhr, textStatus, errorThrown) {
    //   new Kadenze.Notice.error(xhr.responseJSON);
    // });
    self.hideEmailScreen(item, event);
    self.hideShareMenu(item, event);
    event.stopPropagation();
  };

  //TODO: Update to use Kadenze.UIUtil.confirmAction if we add the overflow menu and re-add this funtionality -Jordan
  self.archiveCourse = function(item, event) {
    var $card = $('#course-' + item.id());
    self.confirmAction($card, item.number() + ': ' + item.name(), 'Are you sure you want to archive the course ', function() {
      var url = item.current_user.archive_path();
      var method = 'PATCH';

      Kadenze.UIUtil.makeRequest(url, method, null, parent.$el, null, function (data, textStatus, xhr) {
        item.current_user.is_archived(true);
        item.current_user.archived_at(moment().format(Kadenze.I18n.t('date.formats.js_default')));
        new Kadenze.Notice.success(data);
      }, function (xhr, textStatus, errorThrown) {
        new Kadenze.Notice.error(xhr.responseJSON);
      });
    }, function() {
    });
    self.hideOptionsMenu($card);
    event.stopPropagation();
  };

  //TODO: Update to use Kadenze.UIUtil.confirmAction if we add the overflow menu and re-add this funtionality -Jordan
  self.cloneCourse = function(item, event) {
    var $card = $('#course-' + item.id());
    self.confirmAction($card, item.number() + ': ' + item.name(), 'Are you sure you want to clone the course ', function() {
      var url = item.current_user.clone_path();
      var method = 'POST';
      var data = {course: {name: item.name() + ' Clone', number: item.number(), term_id: item.term_id()}, copy_from: item.id()};

      Kadenze.UIUtil.makeRequest(url, method, data, parent.$el, null, function (data, textStatus, xhr) {
        new Kadenze.Notice.success(data);
      }, function (xhr, textStatus, errorThrown) {
        new Kadenze.Notice.error(xhr.responseJSON);
      });
    }, function() {
    });
    self.hideOptionsMenu($card);
    event.stopPropagation();
  };

  self.acceptInvitation = function(item, event) {
    var $card = $('#course-' + item.id());
    var url = item.current_user.accept_invitations_path;
    var method = 'GET';

    // KADWEB-12194 - very strange that this should be
    if (typeof(url) == 'function')
      url = url();

    Kadenze.UIUtil.makeRequest(url, method, null, parent.$el, null, function (data, textStatus, xhr) {
      item.current_user.is_invited(false);
      item.current_user.is_enrolled(true);
      new Kadenze.Notice.success(data);
    }, function (xhr, textStatus, errorThrown) {
      new Kadenze.Notice.error(xhr.responseJSON);
    });
    self.hideOptionsMenu($card);
    event.stopPropagation();
  };

  self.declineInvitation = function(item, event) {
    var $card = $('#course-' + item.id());
    Kadenze.UIUtil.confirmAction('Are you sure you want to decline the invitation to join the course ',
      function() {
        var url = item.current_user.decline_invitations_path();
        var method = 'DELETE';

        // KADWEB-12194 - very strange that this should be
        if (typeof(url) == 'function')
          url = url();

        Kadenze.UIUtil.makeRequest(url, method, null, parent.$el, null, function (data, textStatus, xhr) {
          parent.courses.remove(item);
          new Kadenze.Notice.success(data);
        }, function (xhr, textStatus, errorThrown) {
          new Kadenze.Notice.error(xhr.responseJSON);
        });
      });

    self.hideOptionsMenu($card);
    event.stopPropagation();
  };

  self.bindData = function(data) {
    ko.mapping.fromJS(data, {}, self);
    self.shareEmails = ko.observable();
  };

  const __construct = function(that) {
    console.log('constructor called for CourseCardViewModel');
    that.bindData(data);
  }(this);
}
